// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export interface Req{
  status: number;
  data: any[];
}

export interface ReqCommerce{
  status: number;
  data: Commerce;
}

export interface Commerce{
  avatar: string;
  address: string;
  bg: string;
  id: number;
  categories: Category[];
  name: string;
  opened: number;
  subtitle_app: string;
  delivery_price: number;
  delivery_min: number;
  delivery_order_min;
  delivery_price_min: number;
  public_phone: string;
  estimated_time: string;
  commerce_info: string;
  availables_time: any[];
  info_zones: string;
  hide_takeaway: number;
  take_away_message: string;
  delivery_price_address: number;
  postal_code: string;
  role_id: number;
}

export const loadOpt = {
  message: 'Cargando...',
};

export interface Auth{
  email: string;
  pass: string;
}

export interface Category{
  name: string;
  products: Product[];
  num_products: number;
  id_category: number;
}

export interface Product{
  id_product: number;
  name: string;
  description: string;
  img: string;
  price: number;
  orders: number;
  state: number;
  extras: Extras[];
  user_id: number;
}

export interface Extras{
  added: number;
  name_extra: string;
  price_extra: number;
}

export interface Register{
  email: string;
  name: string;
  pass_repeat: string;
  pass: string;
  phone: string;
  last_name: string;
  address: string;
  number: string;
  door: string;
  postal_code: string;
}

export interface Delivery{
  address: string;
  adjust_tax: number;
  adjust_tax_add: number;
  base_tax: number;
  card_add: number;
  cash_add: number;
  cod_delivery: string;
  created_at: string;
  client_time: string;
  delivery_man_id: string;
  delivery_man_name: string;
  deliveryman_total: number;
  discount: number;
  discountvol2: number;
  discountvol3: number;
  discountvol4: number;
  email: string;
  extra_size: number;
  extra_time_add: number;
  from_lat: string;
  from_lng: string;
  id_delivery: number;
  lat: string;
  lng: string;
  name: string;
  observations: string;
  observations_client: string;
  payment_method: number;
  payment_method_text: string;
  phone: string;
  postal_code: string;
  // door: string;
  // number: string;
  price: number;
  state: number;
  state_class: string;
  ticket: string;
  time: string;
  total_tax: number;
  total_tax_details: string;
  updated_at: string;
  user_avatar: string;
  user_id: number;
  user_name: string;
}

export interface User{
  id: number;
  token: string;
  email: string;
  role: number;
  active: number;
  address: string;
  avatar: string;
  cif: string;
  company: string;
  created_at: null;
  description: null;
  email_verified_at: string;
  from_lat: string;
  from_lng: string;
  initials: string;
  legal_address: string;
  name: string;
  last_name: string;
  opinion: null;
  phone: string;
  postal_code: string;
  updated_at: string;
  verification_sms_code: string;
}

export interface AddressInterface {
  address: string;
  id_address: number;
  postal_code: string;
  number: string;
  door: string;
  primary: number;
  state: number;
  user_id: number;
  lat: string;
  lng: string;
}

export interface Tarjet{
  cardNumber: number;
  date: number;
  cvc: number;
}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
